import { VariantDetails } from 'modules/experiments/components/ui';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { getTestingSubjectText, italicizedTFunction } from 'modules/experiments/utils';
import { ExperimentType, MessageMedium } from 'modules/graphql';
import { MemoSearchableText } from 'ui-beta/searchableText';

import { BasePageExperimentVariantProperties } from 'modules/experiments/types';
import {
  ExpandedCell,
  ExperimentDetailItem,
  ExperimentDetails,
  VariationItem,
  VariationList,
  VariationTestSubjectContent,
} from './Styled';

export type ExpandedNameCellContentProps = {
  id: number;
  campaignId: number;
  messageMedium: MessageMedium;
  searchedText: string;
  evenlySplitVariations: boolean;
  sendTimeUseRecipientTimeZones: boolean;
  variationsWithControlFirst: BasePageExperimentVariantProperties[];
  type: ExperimentType;
};

export const ExpandedNameCellContent = ({
  id,
  campaignId,
  messageMedium,
  searchedText,
  evenlySplitVariations,
  sendTimeUseRecipientTimeZones,
  variationsWithControlFirst,
  type,
}: ExpandedNameCellContentProps) => {
  const { t } = useExperimentsTranslations();
  return (
    <ExpandedCell data-test={`collapsible-experiment-variations`}>
      <ExperimentDetails>
        <ExperimentDetailItem>
          <MemoSearchableText
            isCaseSensitive={false}
            text={t('table.nameCell.experimentId', { id })}
            searchText={searchedText || ''}
          />
        </ExperimentDetailItem>
        <ExperimentDetailItem>
          <MemoSearchableText
            isCaseSensitive={false}
            text={t('table.nameCell.campaignId', { id: campaignId })}
            searchText={searchedText || ''}
          />
        </ExperimentDetailItem>
        <ExperimentDetailItem>
          {t('table.nameCell.randomlySplitVariants', {
            response: evenlySplitVariations ? t('testStrategy.allUsers') : t('testStrategy.subset'),
          })}
        </ExperimentDetailItem>
      </ExperimentDetails>
      <VariationList>
        {variationsWithControlFirst.map((variation) => (
          <VariationItem key={variation.id}>
            <VariantDetails
              id={variation.id}
              name={variation.name}
              messageMedium={messageMedium}
              subTitle={t('variantTable.cell.templateId', { id: variation.id })}
              templateThumbnailUrl={variation.templateThumbnailUrl}
              control={variation.control}
              winner={variation.winner}
            />
            <VariationTestSubjectContent>
              <>
                {getTestingSubjectText({
                  content: variation.content,
                  sendTime: variation.sendTime,
                  sendTimeUseRecipientTimeZones,
                  messageMedium: variation.messageMedium,
                  control: variation.control,
                  type,
                  t: italicizedTFunction(t),
                })}
              </>
            </VariationTestSubjectContent>
          </VariationItem>
        ))}
      </VariationList>
    </ExpandedCell>
  );
};
